import { Button, TextField } from "@material-ui/core";
import { ethers } from "ethers";
import { getNetworkProvider } from "helper/network";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import React from "react";
import { stakingService } from "../../services/stakingService";

import { abi as StakeAbi } from "../../contracts/StakeV2.1.sol/StakeV2.json";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { isAddress } from "ethers/lib/utils.js";
import { getSigner } from "helper/network";
import detectAndSwitchChain from "helper/switchChain";

// eslint-disable-next-line react/prop-types
export default function StakingBoosterEdit() {
  const { poolAddress } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chainId = params.get("chainId");
  const [boosterAddress, setBoosterAddress] = useState("");
  const [boosterRatio, setBoosterRatio] = useState(0);
  const [loading, setLoading] = useState(false);

  const [boostEnabled, setBoostEnabled] = useState(false);

  async function updateBooster() {
    await detectAndSwitchChain(chainId);
    setLoading(true);
    try {
      const signer = await getSigner();
      const stakeContract = new ethers.Contract(poolAddress, StakeAbi, signer);

      // check pool is running
      const provider = getNetworkProvider();
      const periodFinish = await stakeContract.periodFinish();
      const blockTimestamp = (await provider.getBlock("latest")).timestamp;
      if (blockTimestamp < periodFinish.toNumber()) {
        toast.error("Pool is running");
        return;
      }

      if (!boostEnabled) {
        const tx = await stakeContract.enableBooster(boosterAddress);
        await tx.wait();
      }

      const tx = await stakeContract.setBoosterRatio(boosterRatio * 100);
      await tx.wait();

      // save to db
      await new Promise((resolve) => setTimeout(resolve, 1000));
      await stakingService.syncBoosterDetail(poolAddress);
      toast.success("Update booster success");
    } catch (e) {
      console.log(e);
      if (e.toString().indexOf("Ownable") !== -1) {
        toast.error("Only owner can update booster");
      } else {
        toast.error("Update booster failed");
      }
    } finally {
      setLoading(false);
    }
  }

  async function fetchBooster() {
    if (!isAddress(poolAddress) || !poolAddress) {
      toast.error("Not deploy pool");
      return;
    }
    setLoading(true);
    try {
      const provider = getNetworkProvider();
      const stakeContract = new ethers.Contract(
        poolAddress,
        StakeAbi,
        provider
      );

      const boosterAddress = await stakeContract.booster();
      const boosterRatio = await stakeContract.boosterRatio();

      setBoosterAddress(boosterAddress);
      setBoosterRatio(boosterRatio.toNumber() / 100);
      if (+boosterAddress !== 0) {
        setBoostEnabled(true);
      }
    } catch (e) {
      console.log(e);
      toast.error("Get booster failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBooster();
  }, [poolAddress]);

  return (
    <div>
      <div style={{ marginBottom: "10px", maxWidth: "500px" }}>
        <TextField
          label="Booster address"
          value={boosterAddress}
          onChange={(event) => setBoosterAddress(event.target.value)}
          variant="outlined"
          size="small"
          placeholder="Booster address"
          fullWidth
          disabled={boostEnabled}
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <TextField
          label="Boost percentage (%)"
          value={boosterRatio}
          onChange={(event) => setBoosterRatio(event.target.value)}
          variant="outlined"
          size="small"
          placeholder="Percentage for a booster"
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={updateBooster}
          disabled={loading}
        >
          {loading ? "Loading..." : "Update booster"}
        </Button>
      </div>
    </div>
  );
}
